// extracted by mini-css-extract-plugin
export default {"notices":"Lists_notices__eKgGh","products":"Lists_products__-nGFk","red":"Lists_red__Vtvml","green":"Lists_green__MKEOB","faded":"Lists_faded__IrhlN"};